import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import { OpenInNew } from "mdi-material-ui";
import IconButton_ from "root/entities/Buttons/IconButtons";
import Dialog_ from "root/entities/Dialog";
import { postfixes } from "root/utils";
import { getColumnsByArr } from "root/utils/columns/functions";

import TableSort from "root/components/TableSort";
import Tooltip_ from "root/components/Tooltip";

//
const PublicationCell = ({ url }) => {
  return (
    <Tooltip_ title={"Посмотреть публикацию"}>
      <Box display={"flex"} justifyContent={"center"}>
        <a rel="noreferrer" href={url} target="_blank">
          <IconButton_ sx={{ backgroundColor: "#0fb682 !important" }} variant="filled">
            <OpenInNew />
          </IconButton_>
        </a>
      </Box>
    </Tooltip_>
  );
};
//
const columns = getColumnsByArr(
  [
    { dataIndex: "account_name", title: "Автор публикации" },
    { dataIndex: "url", title: "Открыть публикацию", render: url => <PublicationCell url={url} /> },
    { dataIndex: "view_count", title: `Просмотров,${postfixes.pcs}`, postfix: postfixes.pcs },
    { dataIndex: "like_count", title: `Лайков,${postfixes.pcs}`, sortable: false },
  ].map(item => ({ ...item, sortable: false }))
);
// ----------------------------------------------------------------------------
const SocialNetworksPostsDialog = ({ isOpen, onClose, data }) => {
  // const title = useMemo(() => `Список постов за ${data.date} в ${data.source}`, [data]);
  const title = useMemo(() => `Список постов за ${data.date} в выбранной социальной сети`, [data]);
  return (
    <Dialog_ open={isOpen} onClose={onClose}>
      <Typography mr={3} mb={2} variant={"h6"}>
        {title}
      </Typography>
      <Box className={"scrollBoxMini"}>
        <TableSort data={data.posts || []} columns={columns} />
      </Box>
    </Dialog_>
  );
};

export default SocialNetworksPostsDialog;
